import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ItemClasificacionesGrid from './ItemClasificacionesGrid.jsx';
import ItemClasificacionesAbm from './ItemClasificacionesAbm.jsx';

const ItemClasificaciones = ({ match }) => {

  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="itemClasificaciones.header_administracion_de_clasificaciones"
              defaultMessage="Administración de Clasificaciones"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">  
          <Switch>
            <Route exact path={`${match.url}`} render={(props) => <ItemClasificacionesGrid {...props} />} />
            <Route exact path={`${match.url}/add`} render={props => <ItemClasificacionesAbm {...props} action="ADD" />} />
            <Route exact path={`${match.url}/:id`} render={props => <ItemClasificacionesAbm {...props} action="VIEW" />} />
            <Route exact path={`${match.url}/:id/edit`} render={props => <ItemClasificacionesAbm {...props} action="EDIT" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(ItemClasificaciones);


